import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9acd534c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tw-inline-flex tw-items-center tw-gap-2.5 main__wrapper" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "tw-text-[15px]" }

import { onMounted, ref, watch, Ref } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'tooltip',
  props: {
  /** The show status of tooltip */
  show: {
    type: Boolean,
    required: true,
  },
  /** Element id on DOM */
  id: {
    type: String,
    default: "tooltip",
  },
  /** Delay time before fading (in milliseconds) */
  delay: {
    type: Number,
    default: 4000,
  },
  /** Src of the icon, will be not shown if the value is blank */
  iconSrc: {
    type: String,
    default: "/img/tada_icon.svg",
  },
  /** Variant of tooltip.
   * Valid values: success, danger
   */
  variant: {
    type: String,
    default: "success",
  },
},
  emits: [
  /** Event to emit when close the tooltip */
  "close",
],
  setup(__props, { emit }) {

const props = __props;



const showValue: Ref<boolean> = ref(props.show);


let timeoutId: number | null = null;

const closeTooltip = () => {
  showValue.value = false;
  emit("close");
};

onMounted(() => {
  if (props.delay) {
    timeoutId = setTimeout(() => {
      emit("close");
    }, props.delay);
  }
});

watch(
  () => props.show,
  (newValue: boolean) => {
    showValue.value = newValue;
    if (newValue && props.delay) {
      if (timeoutId) {
        clearTimeout(timeoutId);
      }
      timeoutId = setTimeout(() => {
        closeTooltip();
      }, props.delay);
    }
  },
);

return (_ctx: any,_cache: any) => {
  return (showValue.value)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(["tw-fixed tw-bottom-[60px] tw-left-1/2 tw-translate-x-[-50%] tw-min-w-[350px] tw-max-w-[90vw] tw-inline-flex tw-flex-col tw-justify-center tw-items-center tw-px-5 tw-py-3.5 tw-rounded-md tw-noteInfo tw-z-[99999999991100]", `${__props.variant}`])
      }, [
        _createElementVNode("div", _hoisted_1, [
          (__props.iconSrc)
            ? (_openBlock(), _createElementBlock("img", {
                key: 0,
                src: __props.iconSrc,
                class: "tw-w-[18px] tw-h-[18px] icon tw-flex-shrink-0"
              }, null, 8, _hoisted_2))
            : _createCommentVNode("", true),
          _createElementVNode("span", _hoisted_3, [
            _renderSlot(_ctx.$slots, "default")
          ])
        ])
      ], 2))
    : _createCommentVNode("", true)
}
}

})